import getAppSite from 'utils/getAppSite';

export const getLegislationCurrentStageLabel = (item) => {
  if (getAppSite() === 'usa') {
    return `${item.usLastEventName}`;
  }
  if (item.primaryCurrentHouse === 'Royal Assent') {
    return item.primaryCurrentHouse;
  }
  return item.primaryNextEventName !== null ? item.primaryNextEventName.replace('Date to be announced', 'Date TBA') : '';
};

export const getLegislationCurrentStageClass = (item) => {
  let className = '';
  if (item.primaryCurrentHouse) {
    switch (item.primaryCurrentHouse) {
      case 'Commons':
        className = 'legislation-commons';
        break;
      case 'Lords':
        className = 'legislation-lords';
        break;
      case 'Royal Assent':
        className = 'legislation-royal';
        break;
      default:
        className = 'legislation-grey';
    }
  }
  if (item.secondaryMadeOrLaid) {
    className = 'legislation-grey';
  }
  return className;
};
